<template>
    <div class="attribute-container mb-3">

        <div>
            <label :for="`${componentId}_new-name-text`">{{resource('IOFormat_Attribute_Name_DisplayName')}}</label>
            <input :id="`${componentId}_new-name-text`" type="text" class="form-control" v-model="newName" />
            <required fieldName="Name" v-if="showError"/>
        </div>

        <div>
            <label>{{resource('IOFormat_Attribute_Attribute_DisplayName')}}</label>
            <v-select class="form-control"
                v-model="newValue"
                :options="attributes"

                :disabled="attributes.length === 0"
                :clearable="false"
            >
                <div slot="no-options" />
            </v-select>
        </div>

        <div>
            <label>{{resource('IOFormat_Attribute_Type_DisplayName')}}</label>
            <v-select class="form-control"
                    v-model="newType"
                    :options="types"
                    label="text"
                    :disabled="types.length === 0"
                    :clearable="false"
                >
                    <div slot="no-options" />
            </v-select>
        </div>
        
        <div class="grid-right">
            <button class="btn btn-outline-danger" @click="$emit('delete', value.id)">
                <i class="fas fa-trash-alt"></i>
            </button>
        </div>

    </div>
</template>

<script>
    
import RequiredErrorMessage from "../../../../../Components/Errors/RequiredErrorMessage";
    
import VSelect from 'vue-select';
import api from '../../../api';
import { bootstrapDangerGrowl } from '../../../../../Util/growler';
import resourceMixin from "../../../../../Util/Mixins/resources";
import guidMixin from "../../../../../Util/Mixins/guid";
import { validationMixin  } from 'vuelidate';
import {required} from "vuelidate/lib/validators";

export default {
    name: 'data-attribute',
    components: {
        VSelect,
        Required: RequiredErrorMessage
    },
    mixins: [resourceMixin, validationMixin, guidMixin],
    created() {
        api.getIoItemTypes().then((types) => {
            this.types = types;
            
            //Ensure our parent knows of our selected type
            if(!this.type){
                this.newType = types[0];
            }
        }, bootstrapDangerGrowl);
    },
    computed: {
        newValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', {
                    id: this.value.id,
                    entityId: value.entityId,
                    label: value.label,
                    value: value.value
                });
            }
        },
        newName: {
            get() {
                return this.name;
            },
            set(value) {
                this.$v.name.$touch();
                this.$emit('update:name', value)
            }
        },
        newType: {
            get() {
                return this.type || this.types[0];
            },
            set(value) {
                this.$emit('update:type', value)
            }
        },
        componentId(){
            return `attr_${this.guid()}`;
        },
        showError() {
            return !this.isValid && this.$v.name.$dirty
        },
        isValid() {
            return this.$v.name.required;
        }
    },
    watch: {
        isValid(value){
            this.$emit('valid', value);
        }
    },
    validations: {
        name: {
            required
        }
    },
    data() {
        return {
            types: []
        }
    },
    props: {
        name: {
            type: String,
            default: null
        },
        type: {
            type: Object,
            default: null
        },
        value: {
            type: Object,
            required: true
        },
        attributes: {
            type: Array,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped src="../../../Style/data-attribute.scss">

</style>